import React from "react";
import UniqueRegisterCenterInput from "./UniqueRegisterCenterInput";
import SentenceInput from "../SentenceInput";
import CommonCenterInput from "./CommonCenterInput";
import NullInput from "../NullInput";

export default function DocCenterInput(props) {
  switch (props.doctype) {
    case 1:
      case 3:
      // паспорт зразка 1993 року
      // return <PassportCenterInput {...props} />;
      return <SentenceInput {...props} />;
    case 2:
      case 5:
      case 6:
       
      // паспорт зразка 2016 року
      return <UniqueRegisterCenterInput {...props} />;
    // case 3:
    //   // свідоцтво про народження дитини
    //   // return <ChildBirthSertificateCenterInput {...props} />;
    //   return <SentenceInput {...props} />;
    case 4:
      // тимчасове посвідчення на проживання
      // return <ResidenceCertificateCenterInput {...props} />;
      // return <CommonCenterInput {...props} />;
    case 99:
      // інший документ
      // return <AnyDocCenterInput {...props} />;
      return <SentenceInput {...props} />;
    default:
      return <NullInput {...props} />;
  }
}
